import React, { useEffect, useRef } from 'react';
import SignaturePad from 'signature_pad';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const SignatureColumn = ({sendSignatureToServer}) => {
  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      penColor: 'rgb(0, 0, 0)'
    });
    signaturePadRef.current = signaturePad;

    return () => {
      signaturePad.off();
    };
  }, []);

  const clearSignature = () => {
    const signaturePad = signaturePadRef.current;
    signaturePad.clear();
    document.getElementById("note").innerHTML = "Zde se prosím podepište";
  };

  const saveSignature = () => {
    const signaturePad = signaturePadRef.current;
    if (signaturePad.isEmpty()) {
      alert("Prosíme, nejdříve se podepište");
    } else {
      const dataUrl = signaturePad.toDataURL();
      sendSignatureToServer(dataUrl)
    }
  };

  const handleMouseOver = () => {
    document.getElementById("note").innerHTML = "";
  };

  return (
    <div id="signature-pad">
      <div id="divOfNote">
       
        <canvas id="the_canvas" width="250" height="100" ref={canvasRef} style={{borderBottom: '1px solid red'}}>

        </canvas>
        <div id="note" onMouseOver={handleMouseOver}>Zde se prosím podepište</div>
      </div>
      <div style={{display:'flex', gap: 10}}>
        <Button  data-action="clear"  variant="primary" onClick={saveSignature} size={'sm'}>Uložit smlouvu</Button>
        <Button  data-action="clear"  variant="danger" onClick={clearSignature} size={'sm'}>Smazat podpis</Button>
      </div>
     
 
     
     

      <input type="hidden" id="signature" name="signature" />
    </div>
  );
};

export default SignatureColumn;
